import React, { Suspense } from 'react';
import ErrorBoundary from '../ErrorBoundary';

const LazyLoad = (importFunction, fallback = null) => {
  const retry = 3;
  const Component = React.lazy(() => componentLoader(importFunction, retry));
  return (props) => {
    return (
      <ErrorBoundary>
        <Suspense fallback={fallback}>
          <Component {...props} />
        </Suspense>
      </ErrorBoundary>
    );
  };
};

const componentLoader = (importFunction, retry) => {
  return new Promise((resolve, reject) => {
    importFunction()
      .then(resolve)
      .catch((error) => {
        console.warn('Error in lazy loading. Going to retry. Current retry count: ', retry, 'Error:', error);
        setTimeout(() => {
          if (retry === 1) {
            console.error('Error in lazy loading: ', error);
            return;
          }
          componentLoader(importFunction, retry - 1);
        }, 1000);
      });
  });
};

export default LazyLoad;
